controllers.controller('InvestController', [
    '$scope', '$state', '$filter', '$q', '$timeout', '$ionicScrollDelegate',
    'config', 'constants', 'Utils', 'ErrorService', 'AssetService', 'API', 'UserService',
    'InvestCalcService', 'CurrencyConvertService', 'LocaleService', 'PnlMarginService', 'Storage',
    function ($scope, $state, $filter, $q, $timeout, $ionicScrollDelegate,
              config, Const, Utils, ErrorService, AssetService, API, UserService,
              InvestCalcService, CurrencyConvertService, LocaleService, PnlMarginService, Storage) {
        $scope.user = UserService.get();
        if ($scope.user && !$scope.user.activeTradingAccount) {
            $state.go('signupPersonalProfile', {cache: false});
        }

        $scope.navigate = function (state, params) {
            $state.go(state, params);
        };

        $scope.isFooter = true;
        $scope.showFooter = function () {
            $scope.isFooter = true;
        };
        $scope.backPage = $state.params.backPage ? $state.params.backPage : 'root.app.assets';

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.category = $state.params.category;
        var assetId = $state.params.assetId;
        $scope.constants = Const;
        $scope.action = $state.params.action;
        $scope.asset = null;
        $scope.sltpAutoSet = Const.sltpAutoSet || false;
        $scope.hideSlTp = Const["hideSlTp"] || false;
        $scope.showConvertToUsd = Const["showConvertToUsd"] || false;

        $scope.investAmount = {
            value: '0.01'
        };

        $scope.rate = {
            checked: false,
            value: 0
        };

        $scope.asset = AssetService.collection.get({id: parseInt(assetId, 10)});

        if ($state.params.volume) {
            $scope.investAmount.value = $state.params.volume;
        } else {
            $scope.investAmount.value = $scope.asset.minLot < 1
                ? $scope.constants.defaultInvestAmount
                : $scope.asset.minLot.toFixed(2);
        }

        $scope.rate.value = ($scope.action.match(/^buy/))
            ? $scope.asset.markupAsk().toFixed($scope.asset.digits)
            : $scope.asset.markupBid().toFixed($scope.asset.digits);

        var stopLimit = InvestCalcService.getPipsLimit($scope.asset);
        var stopLimitTakeProfit = Math.ceil($scope.asset.stopLevels / 10);
        $scope.convAssets = CurrencyConvertService.find(AssetService, $scope.user.currency, 'USD', '', 1);


        var defaultPl = {
            checked: false,
            pips: {
                value: stopLimit || 0,
                lock: true,
                keyboard: "text"
            },
            rate: {
                value: 0,
                lock: false,
                keyboard: "text"
            }
        };
        var defaultPlTakeprofit = {
            checked: false,
            pips: {
                value: stopLimitTakeProfit || 0,
                lock: true,
                keyboard: "text"
            },
            rate: {
                value: 0,
                lock: false,
                keyboard: "text"
            }
        };

        var disabledPl = {
            checked: false,
            pips: {
                value: '',
                lock: false,
                keyboard: "text"
            },
            rate: {
                value: '',
                lock: false,
                keyboard: "text"
            }
        };

        var defaultReach = {
            checked: false,
            value: '0.0000',
            keyboard: "text"
        };

        $scope.loss = angular.copy(disabledPl);
        $scope.profit = angular.copy(disabledPl);
        $scope.reach = angular.copy(defaultReach);

        $scope.keyboardModelName = null;
        $scope.isKeyboardShow = false;
        $scope.pow = Math.pow;

        $scope.inputFocus = function (model, name, minval, maxval, digits, viewName) {

            if ((model.hasOwnProperty('lock') && !model.lock) || (model.hasOwnProperty('checked') && !model.checked)) {
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
                return;
            }

            $scope.isKeyboardShow = true;
            $scope.keyboardModelName = {
                model: model,
                name: name,
                minval: minval,
                maxval: maxval,
                digits: digits,
                viewName: viewName,
            };
            $scope.showFooter();
        };

        $scope.myCallback = function (arg) {
            if (arg) {
                _.set($scope, arg.name, arg.model.value);
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
            } else {
                $scope.isKeyboardShow = false;
                $scope.keyboardModelName = null;
            }
        };

        //pl: profit/loss, type: pips/rate
        $scope.lock = function (pl, type) {
            //hide footer
            $scope.isFooter = false;

            //unlock all fields and make their type=text
            unlockAll($scope[pl]);

            //lock current field
            $scope[pl][type].lock = true;

            //change field type to number only for android
            if (Storage.get('platform') === 'android') {
                $scope[pl][type].keyboard = 'number';
            }

            //scroll to bottom
            $ionicScrollDelegate.scrollBottom(true);
        };

        $scope.updateReach = function () {
            //hide footer
            $scope.isFooter = false;

            //change field type to number only for android
            if (Storage.get('platform') === 'android') {
                $scope.reach.keyboard = 'number';
            }

            $ionicScrollDelegate.scrollBottom(true);
        };

        //turn off all locked properties
        function unlockAll(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop) && obj[prop].hasOwnProperty('lock')) {
                    obj[prop].lock = false;
                }
                if (obj.hasOwnProperty(prop) && obj[prop].hasOwnProperty('keyboard')) {
                    obj[prop].keyboard = "text";
                }
            }
        }

        function resetObj(obj, defObj) {
            var def = angular.copy(defObj);
            delete def.checked;
            angular.merge(obj, def);
        }

        $scope.pnlData = PnlMarginService.data;

        var lossCheckWatch = $scope.$watch('loss.checked', function (newVal, oldVal) {
            //turn on loss - reset to default
            if (newVal !== oldVal && newVal) {
                resetObj($scope.loss, defaultPl);
            }
            //turn off loss - clear all fields
            if (newVal !== oldVal && !newVal) {
                $scope.loss = angular.copy(disabledPl);
            }
        });

        var profitCheckWatch = $scope.$watch('profit.checked', function (newVal, oldVal) {
            //turn on profit - reset to default
            if (newVal !== oldVal && newVal) {
                resetObj($scope.profit, defaultPlTakeprofit)
            }
            //turn off profit - clear all fields
            if (newVal !== oldVal && !newVal) {
                $scope.profit = angular.copy(disabledPl);
            }
        });

        var lossPipsWatch = $scope.$watch('loss.pips.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && !$scope.loss.rate.lock) {
                $scope.loss.rate.value = calcLossRate();
            }
        });

        var lossRateWatch = $scope.$watch('loss.rate.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && !$scope.loss.pips.lock) {
                $scope.loss.pips.value = parseInt(calcLossPips(), 10);
            }
        });

        var profitPipsWatch = $scope.$watch('profit.pips.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && !$scope.profit.rate.lock) {
                $scope.profit.rate.value = calcProfitRate();
            }
        });

        var profitRateWatch = $scope.$watch('profit.rate.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && !$scope.profit.pips.lock) {
                $scope.profit.pips.value = parseInt(calcProfitPips(), 10);
            }
        });

        var assetWatch = $scope.$watchGroup(['asset.bid', 'asset.ask'], function (newVal, oldVal) {
            if (newVal && oldVal && (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1])) {
                reCalc();
            }
        });

        function reCalc() {
            if ($scope.loss.checked) {
                //if loss field is not locked - calculate if automatically
                if (!$scope.loss.rate.lock) {
                    $scope.loss.rate.value = calcLossRate();
                }
                //pips field is not locked - calculate if automatically
                if (!$scope.loss.pips.lock) {
                    $scope.loss.pips.value = parseInt(calcLossPips(), 10);
                }
            }

            if ($scope.profit.checked) {
                //if loss field is not locked - calculate if automatically
                if (!$scope.profit.rate.lock) {
                    $scope.profit.rate.value = calcProfitRate();
                }
                //pips field is not locked - calculate if automatically
                if (!$scope.profit.pips.lock) {
                    $scope.profit.pips.value = parseInt(calcProfitPips(), 10);
                }
            }
        }

        var reachWatch = $scope.$watch('reach.checked', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                if (newVal) {
                    $ionicScrollDelegate.scrollBottom(true);
                    $scope.reach.value = $scope.action.match(/^buy/) ? $scope.asset.markupAsk() : $scope.asset.markupBid();
                } else {
                    resetObj($scope.reach, defaultReach);
                    $scope.action = $state.params.action;
                }
                reCalc();
            }
        });

        var reachValueWatch = $scope.$watch('reach.value', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal && $scope.reach.checked) {
                updateAction();
                reCalc();
            }
        });

        function updateAction() {
            var reachValue = parseFloat($scope.reach.value);

            if ($scope.action.match(/^buy/)) {
                (reachValue < $scope.asset.markupAsk()) && ($scope.action = 'buy_limit');
                (reachValue > $scope.asset.markupAsk()) && ($scope.action = 'buy_stop');
            } else if ($scope.action.match(/^sell/)) {
                (reachValue > $scope.asset.markupBid()) && ($scope.action = 'sell_limit');
                (reachValue < $scope.asset.markupBid()) && ($scope.action = 'sell_stop');
            }

            log('action updated', $scope.action);
        }

        $scope.requiredMargin = function () {
            var margin = 0,
                user = UserService.get();
            if ($scope.asset && parseFloat($scope.investAmount.value) > 0) {
                margin = InvestCalcService.calcMargin(parseFloat($scope.investAmount.value), $scope.action || 'buy', $scope.asset, user);
            }

            return margin ? margin.baseVal : 0;
        };

        $scope.requiredMarginUsd = function () {
            return CurrencyConvertService.doConvert($scope.convAssets, Utils.decimalRound($scope.requiredMargin(), $scope.user.currencyDigits), 'buy', 1);
        };

        //calculate takeProfit or stopLoss from pips/rate
        function calcProfitPrice(action, pointsRateVal, pointsRateStatus, sltp, investAmount) {
            var user = UserService.get(),
                openPrice = $scope.reach.checked ? parseFloat($scope.reach.value) : InvestCalcService.getOpenPrice(action, $scope.asset),
                closePrice = pointsRateStatus === 1 ?
                    InvestCalcService.getClosePrice(action, $scope.asset, openPrice, parseFloat(pointsRateVal), sltp) :
                    pointsRateVal,
                lots = investAmount,
                assetCurrency = $scope.asset.currency,
                userCurrency = user.currency,
                pairVal = InvestCalcService.getPairVal(action, openPrice, closePrice, $scope.asset.digits),
                baseVal;

            if ($scope.asset.profitMode === 0) {
                assetCurrency = $scope.asset.outputName.slice(-3);
            }

            if ($scope.asset.profitMode < 2) {
                baseVal = pairVal * $scope.asset.contractSize * lots;
            } else {
                baseVal = pairVal * ($scope.asset.tickPrice / $scope.asset.tickSize) * lots;
            }

            baseVal = CurrencyConvertService.doConvert($scope.asset.convAssets, baseVal, action, $scope.asset.profitMode);

            return parseFloat(baseVal);
        }

        $scope.availableFundsUsd = function () {
            return CurrencyConvertService.doConvert($scope.convAssets, Utils.decimalRound($scope.pipValue(), $scope.user.currencyDigits), 'buy', 1);
        };


        //loss calculations
        function calcLossRate() {
            var digits = $scope.asset.digits,
                points = InvestCalcService.getPoints(parseFloat($scope.loss.pips.value) * 10, digits),
                price = $scope.reach.checked ? parseFloat($scope.reach.value) : InvestCalcService.currentPrice($scope.action, $scope.asset);
            return calcLoss($scope.action, price, points, digits);
        }

        function calcLossPips() {
            var rateRaw = 0,
                pips = 0,
                price = $scope.reach.checked ? parseFloat($scope.reach.value) : InvestCalcService.currentPrice($scope.action, $scope.asset);

            if ($scope.action.match(/^sell/)) {
                rateRaw = $scope.loss.rate.value - price;
            }
            if ($scope.action.match(/^buy/)) {
                rateRaw = price - $scope.loss.rate.value;
            }
            pips = InvestCalcService.fromPoints(rateRaw / 10, $scope.asset.digits);

            return parseInt(pips, 10);
        }

        $scope.calcLossValue = function () {
            if (!$scope.asset) return;

            var pipsRate = $scope.loss.pips.lock ? 1 : 2,
                pipsRateValue = pipsRate === 1 ? $scope.loss.pips.value * 10 : $scope.loss.rate.value,
                lossValue = pipsRateValue > 0
                    ? calcProfitPrice($scope.action, pipsRateValue, pipsRate, 'stopLoss', parseFloat($scope.investAmount.value))
                    : 0;
            return $scope.loss.checked ? lossValue : 0;
        };

        //profit calculations
        function calcProfitRate() {
            var digits = $scope.asset.digits,
                points = InvestCalcService.getPoints(parseFloat($scope.profit.pips.value) * 10, digits),
                price = $scope.reach.checked ? parseFloat($scope.reach.value) : InvestCalcService.currentPrice($scope.action, $scope.asset);

            return calcProfit($scope.action, price, points, digits);
        }

        function calcProfitPips() {
            var rateRaw = 0,
                pips = 0,
                price = $scope.reach.checked ? parseFloat($scope.reach.value) : InvestCalcService.currentPrice($scope.action, $scope.asset);

            if ($scope.action.match(/^sell/)) {
                rateRaw = price - $scope.profit.rate.value;
            }
            if ($scope.action.match(/^buy/)) {
                rateRaw = $scope.profit.rate.value - price;
            }
            pips = InvestCalcService.fromPoints(rateRaw / 10, $scope.asset.digits);

            return parseInt(pips, 10);
        }

        $scope.calcProfitValue = function () {
            if (!$scope.asset) return;

            var pipsRate = $scope.profit.pips.lock ? 1 : 2,
                pipsRateValue = pipsRate === 1 ? $scope.profit.pips.value * 10 : $scope.profit.rate.value,
                profitValue = pipsRateValue > 0
                    ? calcProfitPrice($scope.action, pipsRateValue, pipsRate, 'takeProfit', parseFloat($scope.investAmount.value))
                    : 0;
            return $scope.profit.checked ? profitValue : 0;
        };


        function calcProfit(action, price, points, digits) {
            if (action.match(/^sell/)) {
                return (price - points).toFixed(digits);
            }

            if (action.match(/^buy/)) {
                return (price + points).toFixed(digits);
            }
        }

        function calcLoss(action, price, points, digits) {
            if (action.match(/^sell/)) {
                return (price + points).toFixed(digits);
            }

            if (action.match(/^buy/)) {
                return (price - points).toFixed(digits);
            }
        }

        $scope.pipValue = function (action) {
            var _action = action || 'buy';
            if ($scope.asset && parseFloat($scope.investAmount.value) > 0) {
                return calcProfitPrice(_action, 10, 1, 'takeProfit', $scope.investAmount.value);
            }
            return 0;
        };

        function autoSetSlTp() {
            $scope.loss.checked = true;
            $scope.profit.checked = true;
            $scope.lock('profit', 'pips');
            $scope.lock('loss', 'pips');
            var calcPipsValue = Math.max(Math.floor($scope.requiredMargin() / $scope.pipValue($scope.action)), stopLimit);
            var calcPipsTakeprofitValue = Math.max(Math.floor($scope.requiredMargin() / $scope.pipValue($scope.action)), stopLimitTakeProfit);
            $scope.loss.pips.value = calcPipsValue.toString();
            $scope.profit.pips.value = calcPipsTakeprofitValue.toString();
            reCalc();
            $scope.showFooter();
        }

        $scope.sltpAutoSet && autoSetSlTp();

        function validateLimitStop() {
            var asset = $scope.asset,
                action = $scope.action,
                isReach = $scope.reach.checked,
                reach = parseFloat($scope.reach.value),
                stopLevels = asset.stopLevels,
                diff;
            switch (action) {
                case 'buy_stop':
                    diff = Utils.getDiffInPoints(reach, asset.markupAsk(), asset.digits);
                    return isReach && reach > asset.markupAsk() && diff >= stopLevels;
                case 'sell_stop':
                    diff = Utils.getDiffInPoints(reach, asset.markupBid(), asset.digits);
                    return isReach && reach < asset.markupBid() && diff >= stopLevels;
                case 'sell_limit':
                    diff = Utils.getDiffInPoints(reach, asset.markupBid(), asset.digits);
                    return isReach && reach > asset.markupBid() && diff >= stopLevels;
                case 'buy_limit':
                    diff = Utils.getDiffInPoints(reach, asset.markupAsk(), asset.digits);
                    return isReach && reach < asset.markupAsk() && diff >= stopLevels;
                default:
                    return false;
            }
        }

        function validateBuySell() {
            if (!$scope.asset) return;

            var action = $scope.action,
                asset = $scope.asset,
                profit = ($scope.profit.pips.lock ? calcProfitRate() : parseFloat($scope.profit.rate.value)) || 0,
                loss = ($scope.loss.pips.lock ? calcLossRate() : parseFloat($scope.loss.rate.value)) || 0,
                isReach = $scope.reach.checked,
                reach = parseFloat($scope.reach.value);


            function stopLimitCheck() {
                if (profit === 0) {
                    return parseFloat($scope.loss.pips.value) >= stopLimit;
                } else if (loss === 0) {
                    return parseFloat($scope.profit.pips.value) >= stopLimitTakeProfit;
                } else {
                    return parseFloat($scope.loss.pips.value) >= stopLimit
                        && parseFloat($scope.profit.pips.value) >= stopLimitTakeProfit;
                }
            }

            if (action.match(/^buy/)) {
                if (profit === 0 && loss === 0) {
                    return true;
                } else if (profit === 0) {
                    return (isReach ? reach > loss : asset.markupAsk() > loss) && stopLimitCheck();
                } else if (loss === 0) {
                    return (isReach ? reach < profit : asset.markupAsk() < profit) && stopLimitCheck();
                } else {
                    return (isReach ? (reach < profit && reach > loss) : (asset.markupAsk() < profit && asset.markupAsk() > loss))
                        && stopLimitCheck();
                }
            }

            if (action.match(/^sell/)) {
                if (profit === 0 && loss === 0) {
                    return true;
                } else if (profit === 0) {
                    return (isReach ? reach < loss : asset.markupBid() < loss) && stopLimitCheck();
                } else if (loss === 0) {
                    return (isReach ? reach > profit : asset.markupBid() > profit) && stopLimitCheck();
                } else {
                    return (isReach ? (reach > profit && reach < loss) : (asset.markupBid() > profit && asset.markupBid() < loss))
                        && stopLimitCheck();
                }
            }
        }

        $scope.validate = function () {
            if (!$scope.asset) return;

            var isValidated = validateBuySell(),
                amount = parseFloat($scope.investAmount.value);

            if ($scope.reach.checked) {
                var isReachValidated = validateLimitStop();
                return (amount > 0 && isValidated && isReachValidated)
            }

            return (amount > 0 && isValidated)
        };

        var modalDefaults = {
            isError: false,
            textTitle: '',
            textContent: '',
            state: false,
            isProcess: false
        };

        $scope.modal = angular.copy(modalDefaults);

        function checkOpenTrade(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'InvestController',
                    type: Const.error.type.VALIDATION,
                    code: data.code || 'orderFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.createTrade = function () {
            var trade = {
                SymbolID: $scope.asset.id,
                Lots: parseFloat($scope.investAmount.value),
                OpenPrice: $scope.reach.checked ?
                    parseFloat($scope.reach.value) :
                    InvestCalcService.getOpenPrice($scope.action, $scope.asset),
                StopLoss: ($scope.loss.pips.lock ? calcLossRate() : parseFloat($scope.loss.rate.value)) || 0,
                TakeProfit: ($scope.profit.pips.lock ? calcProfitRate() : parseFloat($scope.profit.rate.value)) || 0,
                Expiration: 0,
                Cmd: Const.actions[$scope.action],
                Slippage: 0,
                Comment: ''
            };

            $scope.modal.isProcess = true;
            $scope.modal.textTitle = LocaleService.translation.messages.orderProcessing;
            $scope.modal.textContent = '';
            $scope.modal.state = true;
            $scope.modal.isMoney = false;

            return API.mt4OpenPosition(trade)
                .then(checkOpenTrade)
                .then(function (data) {
                    //clear trade parameters
                    $scope.loss = angular.copy(disabledPl);
                    $scope.profit = angular.copy(disabledPl);
                    $scope.reach = angular.copy(defaultReach);
                    $scope.investAmount.value = '';

                    var action = Const.actionsId[data.Trade.Cmd].replace('_limit', '').replace('_stop', ''),
                        price = data.Trade.OpenPrice.toFixed(data.Trade.Digits);

                    $scope.modal.textTitle = data.Trade.Cmd > 1 && data.Trade.Cmd < 6 ? LocaleService.translation.openPending : LocaleService.translation.openPosition;
                    $scope.modal.isError = false;
                    $scope.modal.isProcess = false;

                    $scope.modal.textContent = [
                        "#" + data.Trade.OrderID + '&zwj;',
                        LocaleService.translation[action],
                        data.Trade.OutputName,
                        LocaleService.translation.at,
                        price,
                        LocaleService.translation.successful
                    ].join(' ');

                    $scope.modal.actionText = LocaleService.translation.continueTrading;

                    $scope.modal.back = {state: "root.app.assets", params: {category: $scope.category}};
                })
                .catch(function (error) {
                    //clear trade parameters
                    //$scope.loss = angular.copy(disabledPl);
                    //$scope.profit = angular.copy(disabledPl);
                    //$scope.reach = angular.copy(defaultReach);
                    //$scope.investAmount.value = $scope.asset.minLot.toFixed(2);

                    $scope.modal.textTitle = LocaleService.translation.messages.orderFailed;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code]
                        || LocaleService.translation.messages.general_error_text;

                    $scope.modal.isError = true;
                    $scope.modal.isProcess = false;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;

                    if (error.code && error.code === 1134) {
                        $scope.modal.action2Text = LocaleService.translation.addFunds;
                        $scope.modal.isMoney = true;
                        return;
                    }

                    //$scope.modal.back = {state: "root.app.invest", params: {assetId: assetId, action: $scope.action}};

                })
        };


        function clear() {
            assetWatch();
            lossCheckWatch();
            profitCheckWatch();
            lossPipsWatch();
            lossRateWatch();
            profitPipsWatch();
            profitRateWatch();
            reachWatch();
            reachValueWatch();

            $scope.asset = null;
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            return UserService.kycCheck();
        });

        $scope.$on('$ionicView.beforeLeave', clear);
        $scope.$on('$ionicView.unloaded', clear);
        $scope.$on('clear', clear);
    }]);
